<template>
  <div
    v-if="
      assignation.setup &&
        assignation.setup.courses &&
        assignation.setup.courses.length
    "
    class="ui grid"
  >
    <div class="four wide column">
      <h3 class="ui dividing header">
        {{ $t("courses") }}
      </h3>
      <div class="ui fluid search">
        <input
          class="prompt"
          type="text"
          :placeholder="$t('search course')"
          v-model="courseFilter"
        />
        <div class="results"></div>
      </div>
      <div class="ui vertical secondary menu" ref="tabs">
        <a
          class="item"
          v-for="(course, crsidx) in assignation.setup.courses"
          :key="crsidx"
          :data-tab="'t_' + course.course.uuid"
          v-show="
            courseFilter == '' ||
              course.name.toLowerCase().includes(courseFilter.toLowerCase())
          "
        >
          <i
            class="green check icon"
            v-if="course.preinscribed == course.assigned"
          ></i>
          {{ course.course.name }}</a
        >
      </div>
    </div>
    <div class="twelve wide column">
      <div
        class="ui bottom blue attached tab segment"
        v-for="(course, crsidx) in assignation.setup.courses"
        :key="crsidx"
        :data-tab="'t_' + course.course.uuid"
      >
        <course
          :course="course.course"
          :season="assignation"
          :branches="branches"
          :studying_times="studying_times"
          :careers="careers"
          :section_attributes="section_attributes"
          :maximum_capacity_auto_section="maximum_capacity_auto_section"
          ref="course"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="ui error message">
      <div class="content">
        <div class="header">
          {{ $t("alert") }}
        </div>
        <p>{{ $t("no student is pre-inscribed in this season") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  error_toast,
  //   success_toast,
  enterprise_setup,
} from "@/utils";
// import { Container, Draggable } from "vue-dndrop";
// import draggable from "vuedraggable";
// import { cloneDeep } from "lodash";
import Course from "./Course";

// @ is an alias to /src
export default {
  name: "CourseAssignationDistributionCourseBasedIndex",
  components: {
    Course,
  },
  filters: filters,
  data() {
    return {
      courses: [],
      assignation: { setup: {} },
      branches: [],
      studying_times: [],
      careers: [],
      courseFilter: "",
      section_attributes: [],
      maximum_capacity_auto_section: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    init() {
      let vm = this;
      let distribution_uuid = this.$route.query.i;
      if (distribution_uuid) {
        local_api(vm, "post", "/course/assignation/do-get", {
          u: distribution_uuid,
        })
          .then((assignation) => {
            vm.assignation = assignation;
            vm.$emit("set_assignation", assignation);

            // if (assignation && assignation.setup && assignation.setup.courses) {
            if (assignation && assignation.distinctCourses) {
              let ordered = assignation.distinctCourses.sort((a, b) => {
                return a.course.name.localeCompare(b.course.name);
                // if (a.name > b.name) return 1;
                // else if (a.name < b.name) return -1;
                // else return 0;
              });
              assignation.setup.courses = ordered;
            }

            setTimeout(() => {
              window
                .jQuery(vm.$refs.tabs)
                .find(".item")
                .tab();
            }, 1000);
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course distribution found"));
      }
    },
    setCatalogs(catalogs) {
      this.careers = catalogs.careers || [];
      this.branches = catalogs.branches || [];
      this.studying_times = catalogs.studying_times || [];
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();

    // /**
    //  * Get careers and branches
    //  */
    // local_api(vm, "post", "/student_configuration/do-get-configuration", {})
    //   .then((studentConfiguration) => {
    //     vm.careers = studentConfiguration.std_careers;
    //     vm.branches = studentConfiguration.std_branches;
    //     vm.studying_times = studentConfiguration.std_studying_times;

    //     if (studentConfiguration.std_users) {
    //       console.log(studentConfiguration.std_users);
    //     }

    //     // setTimeout(() => {
    //     //   vm.$refs.course.map((c) => {
    //     //     c.init_dropdowns();
    //     //   });
    //     // }, 500);
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });

    /**
     * Get course assignation module configuration
     */
    local_api(vm, "post", "/course/assignation/do-get-configuration", {})
      .then((r) => {
        if (r && r.conf && r.conf.setup) {
          if (r.conf.setup.attributes) {
            let sectionAttributes = r.conf.setup.attributes;
            vm.section_attributes = sectionAttributes;
          }

          if (r.conf.setup.maximum_capacity_auto_section) {
            vm.maximum_capacity_auto_section = String(
              r.conf.setup.maximum_capacity_auto_section,
            );
          }
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
